import * as __WEBPACK_EXTERNAL_MODULE__assert_index_js_255db76f__ from "../assert/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__toLowerCase_index_js_61aa2a47__ from "../toLowerCase/index.js";
function buildSortPredicate(valueAccessor, direction = 'asc', ignoreCase = true) {
    (0, __WEBPACK_EXTERNAL_MODULE__assert_index_js_255db76f__.assert)([
        'asc',
        'desc'
    ].includes(direction), 'Invalid sort direction');
    const valueProvider = (t)=>{
        const value = valueAccessor ? valueAccessor(t) || '' : t;
        return ignoreCase ? (0, __WEBPACK_EXTERNAL_MODULE__toLowerCase_index_js_61aa2a47__.toLowerCase)(value) : value;
    };
    const directionMultiplier = 'desc' === direction ? -1 : 1;
    return (a, b)=>{
        const aVal = valueProvider(a);
        const bVal = valueProvider(b);
        if (aVal === bVal) return 0;
        let order = 0;
        try {
            order = String(aVal).localeCompare(String(bVal), 'en', {
                numeric: true
            });
        } catch  {
            order = aVal < bVal ? -1 : 1;
        }
        return order * directionMultiplier;
    };
}
export { buildSortPredicate };
